import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const skip = (source, count) => {
    async function* iterator() {
        let i = 0;
        for await (const item of source) {
            if (i++ >= count) {
                yield item;
            }
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
